import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

const ShoppingCartStepperNavigation = ({ onBack, children, currentStep }) => (
  <Stack
    direction="row"
    justifyContent="center"
    alignItems="flex-end"
    width="100%"
    flexGrow={1}
    spacing={2}
  >
    {currentStep !== 0 && (
      <Button variant="secondary" onClick={onBack} sx={{ height: 40 }}>
        Atrás
      </Button>
    )}
    {children}
  </Stack>
);

ShoppingCartStepperNavigation.propTypes = {
  onBack: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  currentStep: PropTypes.number,
};

ShoppingCartStepperNavigation.defaultProps = {
  currentStep: null,
};

export default ShoppingCartStepperNavigation;
